import { Injectable } from '@angular/core';

import { PreferencesService } from '@services/preferences/preferences.service';
import { AgGridReportsService } from '@services/reports/ag-grid-reports.service';

@Injectable({
    providedIn: 'root',
})
export class EmployeeScorecardHelperService {
    constructor(
        private preferencesService: PreferencesService,
        private agGridReportsService: AgGridReportsService,
    ) {}

    public calculateGuestPerLaborHour(guests: string, labor_hours: string) {
        const guestsCount = Number(guests);
        const labor_hours_value = parseFloat(labor_hours);
        if (labor_hours_value === 0) {
            return this.preferencesService.correctRounding('0.00');
        }

        return this.preferencesService.correctRounding(guestsCount / labor_hours_value);
    }

    public calculateSalesPerLaborHour(net_sales: string, labor_hours: string) {
        if (parseFloat(labor_hours) === 0) {
            return this.preferencesService.correctRounding('0.00');
        }

        return this.preferencesService.correctRounding(parseFloat(net_sales) / parseFloat(labor_hours));
    }

    public calculateAVG(first: string, second: string) {
        const firstNum = parseFloat(first);
        const secondNum = Number(second);
        if (secondNum === 0) {
            return 0;
        }

        return firstNum / secondNum;
    }

    public customAvgAggFunction = (params) => {
        let result = 0;
        switch (params.colDef.field) {
            case 'gca':
                if (+this.agGridReportsService.totalSumValues['guests'] === 0) {
                    return 0;
                }
                result += this.agGridReportsService.getTotalAverageValue(
                    +this.agGridReportsService.totalSumValues['net_sales'],
                    +this.agGridReportsService.totalSumValues['guests'],
                );
                break;
            case 'avg_table_time':
                if (+this.agGridReportsService.totalSumValues['total_orders'] === 0) {
                    return 0;
                }
                result += this.agGridReportsService.getTotalAverageValue(
                    +this.agGridReportsService.totalSumValues['table_time'],
                    +this.agGridReportsService.totalSumValues['total_orders'],
                );
                break;
            default:
                if (+this.agGridReportsService.totalSumValues['guests'] === 0) {
                    return 0;
                }
                result +=
                    this.agGridReportsService.getTotalAverageValue(
                        +this.agGridReportsService.totalSumValues[params.colDef.field.replace('%', '')],
                        +this.agGridReportsService.totalSumValues['guests'],
                    ) * 100;
        }
        this.agGridReportsService.updateTotalAverageValues(params.colDef.field, result);

        return result;
    };
}
